import { Button } from "@devhop/ui";
import { Maximize2, Minimize2 } from "lucide-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useBranchCustomerDisplaySettings } from "../api/queries";
import { usePOSContext } from "../context/POSContext";
import { CustomerCartView } from "../ui/CustomerCartView";

export function CustomerDisplayPage() {
  const { selection } = usePOSContext();
  const branchId = selection?.branchId ?? null;
  const { data: displaySettings } = useBranchCustomerDisplaySettings(branchId);
  const paymentQrUrls = displaySettings?.paymentQrUrls ?? [];
  const socialMediaUrls = displaySettings?.socialMediaUrls;

  const containerRef = useRef<HTMLDivElement>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = useCallback(() => {
    const el = containerRef.current;
    if (!el) return;

    if (!document.fullscreenElement) {
      el.requestFullscreen?.() ?? (el as HTMLDivElement & { webkitRequestFullscreen?: () => void }).webkitRequestFullscreen?.();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen?.() ?? (document as Document & { webkitExitFullscreen?: () => void }).webkitExitFullscreen?.();
      setIsFullscreen(false);
    }
  }, []);

  useEffect(() => {
    const handleChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleChange);
    document.addEventListener("webkitfullscreenchange", handleChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleChange);
      document.removeEventListener("webkitfullscreenchange", handleChange);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative flex h-screen flex-col bg-background"
    >
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="absolute top-2 right-2 z-10 opacity-60 hover:opacity-100"
        onClick={toggleFullscreen}
        title={isFullscreen ? "ອອກຈາກເຕັມຈໍ" : "ເຕັມຈໍ"}
      >
        {isFullscreen ? (
          <Minimize2 className="h-5 w-5" />
        ) : (
          <Maximize2 className="h-5 w-5" />
        )}
      </Button>
      <div className="flex-1 overflow-hidden">
        <CustomerCartView
          paymentQrUrls={paymentQrUrls}
          socialMediaUrls={socialMediaUrls}
        />
      </div>
    </div>
  );
}
